import ClientDetailTabTimeline from '@/components/client/timeline/DetailTabTimeline.vue'

const timelineRouter = (beforeEnter, name, singleName, basePath, tabs) => {
    return {
        beforeEnter: beforeEnter,
        name: `${singleName}DetalheAbaTimeline`,
        path: `${basePath}/detalhe/:id/timeline`,
        meta: {
            requiresAuth: true,
            isEmployee: true,
            layout: 'default',
            basePath,
            singleName,
            tabs
        },
        component: ClientDetailTabTimeline
    }
}

export default timelineRouter
